import React from 'react';
import Banner from './Banner';
import StatsSection from './StatsSection'; // अगर StatsSection दूसरे फोल्डर में है तो रास्ता चेक कर लें
import CTASection from './CTASection';
function Home() {
  return (
    <div>
      <Banner />

      {/* About Us Section */}
      <section className="py-5" style={{ backgroundColor: "#f9f9f9" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img src="/images/about-us.jpg" alt="About Us" className="img-fluid rounded shadow-lg" />
            </div>
            <div className="col-md-6">
              <h2 className="mb-4 text-primary fw-bold text-center">About Us</h2>
              <p className="lead text-muted mb-4">
                Satish Office Chair Repair & Service is a trusted name for professional office chair repair and maintenance services. We specialize in repairing all types of office chairs, including executive chairs, revolving chairs, mesh chairs, ergonomic chairs, visitor chairs, gaming chairs, and workstation chairs. With years of hands-on experience, we provide affordable, reliable, and same-day repair solutions for homes, offices, corporate companies, schools, hospitals, and commercial spaces.

Our skilled technicians use high-quality spare parts to ensure your chair is restored to excellent working condition. Whether it's a broken hydraulic, damaged wheel, loose armrest, or torn seat, we offer quick doorstep service at competitive prices.
              </p>
              <div className="row">
                {[
                  { icon: "fa-gem", title: "Quality Products" },
                  { icon: "fa-user-tie", title: "Expertise & Experience" },
                  { icon: "fa-heart", title: "Customer-Centric Approach" },
                  { icon: "fa-layer-group", title: "Comprehensive Services" },
                  { icon: "fa-shield-alt", title: "Reliability" }
                ].map((item, index) => (
                  <div className="col-sm-6 mb-3" key={index}>
                    <div className="d-flex align-items-center">
                      <i className={`fas ${item.icon} text-primary me-3 fa-lg`}></i>
                      <span className="fw-semibold">{item.title}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4">
                <a href="/about" className="btn btn-primary btn-lg shadow-sm px-4">
                  Read More <i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="bg-light py-5">
        <div className="container">
          <h2 className="text-primary fw-bold text-center mb-5">Our Services</h2>
          <div className="row">
            {[ 
              { title: "Office Chair Repair", img: "/images/service1.jpg", desc: "Install new caster wheels." },
              { title: "Mesh Chair Repair", img: "/images/service2.jpg", desc: "Repair damaged mesh backs." },
              { title: "Recliner Mechanism", img: "/images/service3.jpg", desc: "Fix reclining systems." },
              { title: "Computer Chair", img: "/images/service4.jpg", desc: "Affordable repairs." },
              { title: "Gaming Chair", img: "/images/service5.jpg", desc: "Repair hydraulics and wheels." },
              { title: "Seat Cushion", img: "/images/service6.jpg", desc: "Replace damaged foam." }
            ].map((service, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow">
                  <img src={service.img} className="card-img-top" alt={service.title} />
                  <div className="card-body">
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text">{service.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      

     {/* Why Choose Us */}
      <section className="py-5 bg-light">
  <div className="container">
    <h2 className="text-primary fw-bold text-center mb-5">Why Choose Us?</h2>
    
    {/* आपका पुराना सेक्शन (मुख्य फीचर्स) */}
 

   
    <div className="row">
      {[
        { icon: "fa-heart", title: "Same-Day Doorstep Service", desc: "", color: "bg-danger" },
        { icon: "fa-lightbulb", title: "Affordable Repair Charges", desc: "", color: "bg-warning" },
        { icon: "fa-shield-alt", title: "100% Customer Satisfaction", desc: "", color: "bg-success" },
        { icon: "fa-users", title: "Fast, Reliable", desc: "", color: "bg-primary" }
      ].map((item, index) => (
        <div key={index} className="col-md-3 mb-4">
          <div className="card h-100 border-0 shadow-sm p-4 text-center rounded-4">
            <div className={`mx-auto mb-3 p-3 text-white rounded-3 ${item.color}`} style={{ width: "60px", height: "60px" }}>
              <i className={`fas ${item.icon} fa-lg`}></i>
            </div>
            <h5 className="fw-bold">{item.title}</h5>
            <p className="text-muted small">{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Stats Section */}
      <StatsSection />

      {/* Call to Action Section */}
      <CTASection />
      
    </div> // यह <div> पूरे होम पेज को बंद कर रहा है
  );
} // यह function Home() को बंद कर रहा है

export default Home; // यह फाइल को एक्सपोर्ट कर रहा है